import React, { FC, useMemo } from 'react'

import { Nav } from 'modulesCommon/Navigation/components'
import { administrationEntitiesNav, EAdminEntitiesNavLabel } from 'modulesCommon/Navigation/consts'

import './AdminHeader.scss'
import { useReactiveVar } from '@apollo/client'
import { currentUserVar } from 'modulesCommon/store'

const AdminHeader: FC = ({ children }) => {

  const currentUser = useReactiveVar(currentUserVar)

  const navs = useMemo(
    () =>
      currentUser?.role?.role_id === 'admin'
        ? administrationEntitiesNav
        : administrationEntitiesNav.filter((nav) => nav.label !== EAdminEntitiesNavLabel.PRODUCT_CHART_MATCH),
    [currentUser?.role?.role_id]
  )

  return (
    <div
      className="admin-header"
    >
      <Nav navs={navs} isSubNav />
      <div className="page__inline">{children}</div>
    </div>
  )
}

export default AdminHeader
